var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCheck = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 3.26414L28.6991 1.95985L25.691 4.97602C23.0081 1.95985 19.1057 0.00341797 14.7154 0.00341797C6.58534 0.00341797 0 6.60639 0 14.7582C0 22.91 6.58534 29.513 14.7154 29.513C22.8455 29.513 29.4308 22.91 29.4308 14.7582C29.4308 11.6605 28.4552 8.80738 26.9105 6.44335L30 3.26414ZM27.4796 14.7582C27.4796 21.8503 21.7073 27.5565 14.7154 27.5565C7.64225 27.5565 1.95124 21.7688 1.95124 14.7582C1.95124 7.74764 7.72355 1.95985 14.7154 1.95985C18.5366 1.95985 22.0325 3.67173 24.3902 6.36183L14.7967 15.8995L9.91865 11.0084L8.61786 12.3127L14.878 18.508L25.6097 7.82916C26.7479 9.86711 27.4796 12.2311 27.4796 14.7582Z",
    fill: "#00EC25"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCheck);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Check.bd1112082b4a77ff81479546f6b29172.svg";